
import React from 'react'
import { Icon } from 'semantic-ui-react';
import './IPackBoxStatus.css';

const IPackBoxStatus = ({visible,size}) => {
    if(!visible){return null}    
    return (
        <div className="IPackBoxStatus">
            <Icon 
                className="red_inverted_lightbulb blink_me"
                name="lightbulb" 
                size={size ? size : "huge"}
            />
            <b>Väntar på låda</b>
        </div>
        
    )
} 
export default IPackBoxStatus;

